import classNames from 'classnames';
import { forwardRef, type HTMLAttributes } from 'react';

import styles from './InfoTipIcon.module.css';

export interface InfoTipIconProps extends HTMLAttributes<HTMLSpanElement> {
  /** Rendered width/height in px. Defaults to 14. */
  size?: number;
}

/**
 * Information infotip icon: the v1.1 circled "i" glyph. It inherits
 * `currentColor`, so it follows the surrounding themed text token (white in dark, ink in light) while still honouring an explicit
 * colour set by a parent (e.g. an orange warning affordance). forwardRef +
 * prop spread let it act as a Chakra `Tooltip` trigger.
 */
export const InfoTipIcon = forwardRef<HTMLSpanElement, InfoTipIconProps>(
  function InfoTipIcon({ size = 14, className, ...rest }, ref) {
    return (
      <span ref={ref} className={classNames(styles.root, className)} {...rest}>
        <svg
          className={styles.glyph}
          width={size}
          height={size}
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <g opacity="0.7">
            <path
              d="M10.75 6C10.75 8.62335 8.62335 10.75 6 10.75C3.37665 10.75 1.25 8.62335 1.25 6C1.25 3.37665 3.37665 1.25 6 1.25C8.62335 1.25 10.75 3.37665 10.75 6Z"
              stroke="currentColor"
              strokeWidth="0.8"
              strokeLinecap="square"
            />
            <path
              d="M5.25 5.25H6L6 7.75"
              stroke="currentColor"
              strokeWidth="0.8"
              strokeLinecap="square"
            />
            <path
              d="M6.22461 4.02539V4.47461H5.77539V4.02539H6.22461Z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="0.2"
            />
          </g>
        </svg>
      </span>
    );
  }
);
